<script setup>
const props = defineProps({
  pkg: {
    type: Object,
    required: true,
  },
});

function translateLevel(level) {
  if (!level) return "";
  const map = { basic: "Podstawowy", premium: "Premium" };
  return map[level] || level;
}

defineExpose({
  getSummaryEmailHtml,
});

const copyForEmailRef = ref(null);

function getSummaryEmailHtml() {
  return copyForEmailRef.value.formatForEmail();
}
</script>

<template>
  <CopyForEmail ref="copyForEmailRef">
    <div
      style="
        padding: 1.5rem;
        border-radius: 0.75rem;
        border: 1px solid #e5e7eb;
        background-color: #ffffff;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        overflow: hidden;
      "
    >
      <div
        style="
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 1rem;
        "
      >
        <div>
          <h1 style="font-size: 1.25rem; line-height: 1.75rem; font-weight: 600">
            Szczegóły konfiguracji strony
          </h1>
        </div>
      </div>
      <div style="margin-top: 1.5rem">
        <div>
          <h3 style="font-size: 1.125rem; line-height: 1.75rem; font-weight: 600">
            Marketing
          </h3>
          <span style="color: #374151">
            {{ translateLevel(pkg.marketing) }}
          </span>
        </div>

        <div style="margin-top: 1rem">
          <h3 style="font-size: 1.125rem; line-height: 1.75rem; font-weight: 600">
            Design
          </h3>
          <span style="color: #374151">
            {{ translateLevel(pkg.design) }}
          </span>
        </div>

        <div style="margin-top: 1rem">
          <h3 style="font-size: 1.125rem; line-height: 1.75rem; font-weight: 600">
            Sekcje przyciągające klientów
          </h3>
          <span style="color: #374151">
            Ilość: <strong style="margin-left: 0.25rem">{{ pkg.selling }}</strong>
          </span>
        </div>

        <!-- Sections table -->
        <div v-if="pkg.sections?.length" style="margin-top: 1rem">
          <h3 style="font-size: 1.125rem; line-height: 1.75rem; font-weight: 600">
            Sekcje
          </h3>
          <ul>
            <li
              v-for="(section, i) in pkg.sections"
              style="
                padding-top: 0.25rem;
                padding-bottom: 0.25rem;
                display: flex;
                flex-direction: row;
                align-items: center;
              "
            >
              <Icon
                style="font-size: 1.5rem; line-height: 2rem"
                name="material-symbols:fitbit-check-small"
              />
              <span style="color: #374151">{{ section.label }}</span>
            </li>
          </ul>
        </div>

        <!-- Functions -->
        <div v-if="pkg.functions?.length" style="margin-top: 1rem">
          <h3 style="font-size: 1.125rem; line-height: 1.75rem; font-weight: 600">
            Funkcje
          </h3>
          <ul>
            <li
              v-for="(f, i) in pkg.functions"
              style="
                padding-top: 0.25rem;
                padding-bottom: 0.25rem;
                display: flex;
                flex-direction: row;
                align-items: center;
              "
            >
              <Icon
                style="font-size: 1.5rem; line-height: 2rem"
                name="material-symbols:fitbit-check-small"
              />
              <span style="color: #374151">{{ f }}</span>
            </li>
          </ul>
        </div>

        <div v-if="pkg.additional?.length" style="margin-top: 1rem">
          <h3 style="font-size: 1.125rem; line-height: 1.75rem; font-weight: 600">
            Dodatki
          </h3>
          <ul>
            <li
              v-for="(add, i) in pkg.additional"
              style="
                padding-top: 0.25rem;
                padding-bottom: 0.25rem;
                display: flex;
                flex-direction: row;
                align-items: center;
              "
            >
              <Icon
                style="font-size: 1.5rem; line-height: 2rem"
                name="material-symbols:fitbit-check-small"
              />
              <span style="color: #374151">{{ add }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </CopyForEmail>
</template>
